import React from "react";
import { Section, sectionSpacingY } from "components/section";
import { Accordion } from "ui/accordion";
import { TextTitle } from "ui/text";
import { Link } from "ui/link";
import { integrationsCount } from "../../constants/integrations";

const faqItems = [
  {
    title: "What is a destination?",
    content: (
      <>
        A destination is any of the {integrationsCount}+ integrations that Hightouch lets you sync data to. Multiple
        instances of the same destination will only be counted once. Read{" "}
        <Link href="/docs/pricing/ss-pricing" variant="inlineDark" target="_blank">
          our documentation
        </Link>{" "}
        to learn more about{" "}
        <Link variant="inlineDark" target="_blank" href="/docs/pricing/ss-pricing#destinations">
          what counts as a destination
        </Link>
        .
      </>
    ),
  },
  {
    title: "Can I try a new destination before being charged for it?",
    content:
      "Absolutely! Beyond your first free destination, each destination has a 30 day free trial before you are charged for it.",
  },
  {
    title: "Do you offer self-service billing?",
    content: (
      <>
        Yes! We fully support in-app self-service billing for our Free, Starter, and Pro plans. We let you manage your
        plan, explore your usage, and view invoices directly through our UI. Learn more in our{" "}
        <Link href="/docs/pricing/ss-pricing" variant="inlineDark" target="_blank">
          self-serve pricing documentation
        </Link>
        .
      </>
    ),
  },
  {
    title: "Can I pay monthly instead of annually?",
    content:
      "We recommend customers to pay annually. Annual billing includes a 20% discount. However, we also support monthly billing for our self-service plans.",
  },
  {
    title: "Can I ask for help setting up Hightouch even if I'm on the Free plan?",
    content:
      "Yes. We're happy to help customers regardless of their size. Please message us on Intercom, email us, or book a time with us and we'll make sure set up is effortless as possible.",
  },
  {
    title: "Do you have special pricing for early stage startups or businesses affected by Covid?",
    content:
      "For early stage startups (<40 employees or <$10M in funding), we offer six months of our Starter plan for free. For business affected by Covid, please reach out to us and we'll be happy to assess on a case by case basis.",
  },
  {
    title: "What if I have a billing-related question?",
    content:
      "For questions related to payments processing, invoices, discounts, overages, or any other billing-related topics, please message us on Intercom or email us, and we will help you resolve the question.",
  },
];

export function Faq() {
  return (
    <Section my={0} pb={sectionSpacingY}>
      <TextTitle align="center" size="lg" title="Frequently asked questions" />
      <Accordion items={faqItems} maxW="820px" mx="auto" mt={{ base: "bigger", md: "biggest" }} />
    </Section>
  );
}
